export type PlanBadge = 'current' | 'best-value' | null;

/** Card badge precedence for pricing surfaces: the merchant's current plan
 *  always outranks the marketing badge (spec F2/DC-4). */
export function planBadge(isCurrent: boolean, isPremium: boolean): PlanBadge {
  if (isCurrent) { return 'current'; }
  if (isPremium) { return 'best-value'; }
  return null;
}
